export enum EdflexRoutingEnum {
  Formations = 'formations',
  TabSlug = ':tabSlug',
}
